import { combineReducers } from "redux";
import step from "./step";
import order from "./order";
import booking from "./booking";

export default combineReducers({ step, order, booking });
